<template>
    <div>

         <CustomModal v-if="isModalOpen" ref="customModal" :modalId="modalId" :isOpen="isModalOpen" :showFooter="true" @modalClosed="modalClosed" :isStyle="'max-width:100% !important;'">
            
            <template #header>
                <h5 class="modal-title">{{ ['create','transfer'].includes(action) ? $t('create_invoice') : $t('edit_invoice') }}</h5>
                <button type="button" class="btn-close" id="close-modal-btn" data-bs-dismiss="modal" aria-label="Close" @click="modalClosed"></button>
            </template>

            <template #body>
                <div class="modal-body" style="text-align:left">
                        <div class="row">
                            <div class="col-sm-4">
                                <div class="mb-3">
                                    <label for="exampleFormControlInput1"  class="form-label">{{$t('invoice')}}</label>
                                     <auto-complete 
                                        entity="invoices"
                                        emitEvent="emitAutoCompleteInvoice"
                                        :defaultValue="localData?.invoice?.reference" 
                                        @emitAutoCompleteInvoice="emitAutoCompleteInvoice">
                                    </auto-complete>
                                </div>
                            </div>
                            <div class="col-sm-4">
                                <div class="mb-3">
                                    <label for="exampleFormControlInput1"  class="form-label">{{$t('reference')}}</label>
                                    <input v-model="localData.reference" type="string" class="form-control" id="exampleFormControlInput1" placeholder="Reference">
                                </div>
                            </div>
                            <div class="col-sm-4">
                                <div class="mb-3">
                                <label for="exampleFormControlInput1" class="form-label">{{$t('date')}}</label>
                                <input v-model="localData.date" type="date" class="form-control" id="exampleFormControlInput1" placeholder="Reference Date">
                            </div>
                            </div>
                        </div>

                        <hr>
                        <div class="mb-3">
                            <div v-for="(prd,i) in localData.products" :key="i" class="row mb-3">
                                <!-- Product selector: full width on mobile, compact on sm+ -->
                                <div class="col-12 col-sm-5">
                                    <div class="d-flex align-items-center">
                                        <div class="form-check form-switch">
                                            <input
                                                class="form-check-input"
                                                type="checkbox"
                                                id="paymentToggle"
                                                v-model="localData.products[i].custom_product"
                                            >
                                        </div>
                                        <label for="paymentToggle" class="form-label toggle-label me-3">{{localData.products[i].custom_product ? $t('custom_product') : $t('existing_product') }}</label>
                                    </div>

                                <auto-complete  
                                        :uid="i"
                                        v-if="!localData.products[i].custom_product && createClientState === false" 
                                        @emitAutoComplete="emitAutoComplete" 
                                        :defaultValue="localData.products[i].product_label" 
                                        entity="inventories"
                                        emitEvent="emitAutoComplete"
                                        :dislaySuggestions="action =='create' ? true : false " 
                                    ></auto-complete>
                                    <textarea v-if="localData.products[i].custom_product" type="string" v-model="localData.products[i].product_label" class="form-control" placeholder="label" min="0"></textarea>
   
                                </div>
                                <!-- Price -->
                                <div class="col-4 col-sm-1" v-if="localData.products[i].product_id || localData.products[i].custom_product == true">
                                    <label for="exampleFormControlInput1" class="form-label">{{$t('price')}}</label>
                                    <input v-model="localData.products[i].price" @change="calculatePrices" class="form-control" placeholder="Price" type="number">                                
                                </div>
                                <!-- Qty -->
                                <div class="col-4 col-sm-1" v-if="localData.products[i].product_id || localData.products[i].custom_product == true">
                                    <label for="exampleFormControlInput1" class="form-label">{{$t('quantity')}}</label> 
                                    <input v-model="localData.products[i].quantity" @change="calculatePrices" class="form-control" min="0" type="number" step="any" inputmode="decimal" >
                                    <small v-if="localData.products[i].maxQty">{{$t('stock')}}: <b>{{localData.products[i].maxQty}}</b></small>
                                </div>
                                <!-- VAT -->
                                <div class="col-4 col-sm-1" v-if="localData.products[i].product_id || localData.products[i].custom_product == true">
                                    <label for="exampleFormControlInput1" class="form-label">{{$t('vat')}} %</label>
                                    <input v-model.number="localData.products[i].vat" @change="calculatePrices" class="form-control" min="0" max="100" type="number" step="0.01" inputmode="decimal" pattern="[0-9]+(\.[0-9]{1,2})?" >
                                </div>
                                <!-- Subtotal -->
                                <div class="col-4 col-sm-1" v-if="localData.products[i].product_id || localData.products[i].custom_product == true">
                                    <label for="exampleFormControlInput1" class="form-label">{{$t('sub_total')}}: </label>
                                    <input v-model="localData.products[i].sub_total" class="form-control" min="0" max="100" type="number" step="0.01" inputmode="decimal"  >
                                </div>
                                <!-- Total -->
                                <div class="col-4 col-sm-1" v-if="localData.products[i].product_id || localData.products[i].custom_product == true">
                                    <label for="exampleFormControlInput1" class="form-label">{{$t('total')}}: </label>
                                    <input v-model="localData.products[i].total" class="form-control" @change="parseTTctoHt(i,localData.products[i].total)"  min="0" type="number" step="0.01" inputmode="decimal" >
                                </div>
                                <!-- Remove button -->
                                <div class="col-12 col-sm-1"  style="margin-top:25px">
                                    <button type="button" class="mb-3 btn line-item-delete-button" :aria-label="$t('delete')" :title="$t('delete')" @click="removeRow(i)"><AppIcon name="bi-trash" class="bi bi-trash" /></button>
                                </div>
                            </div>  

                            <div class="row">
                                <div class="col-sm-9 btn-add-product">
                                    <button type="button" class="mb-3 btn btn-success" @click="addNewRow"><PlusIcon class="me-1 client-lucide-icon" :size="15" :stroke-width="1.75" aria-hidden="true" /> {{$t('product')}}</button>
                                </div>
                                <div class="col-sm-3" v-if="checkIfValidProduct()">
                                    {{$t('sub_total')}} : <b>{{formatMoney(sub_total)}}</b> <br>
                                    {{$t('total_credited')}} : <b>{{formatMoney(total)}}</b>
                                </div>
                            </div>
                            
                        </div>

                        <hr>
                        <div class="row">
                            <div class="col-sm-3">
                            <label for="exampleFormControlInput1" class="form-label"><strong>{{$t('client')}}</strong></label>
          
                            <auto-complete  
                                    v-if="!modalIsLoading" 
                                    @emitAutoCompleteClient="emitAutoCompleteClient" 
                                    :defaultValue="localData.client ? localData.client.name : ''"
                                    entity="clients"
                                    emitEvent="emitAutoCompleteClient"
                            ></auto-complete>

                            <div class="related-create-link" style="padding: 5px;font-weight: bold;font-size: 12px;" @click="openCreateClientModal">{{$t('create_new_client')}}</div>
                            </div>
                            <div class="col-sm-2">
                                <label for="exampleFormControlInput1" class="form-label"><strong>{{$t('status')}}</strong></label>
                                    <select v-model="localData.status" class="form-select" aria-label="Default select example">
                                        <option  selected value="draft">{{$t('draft')}}</option>
                                        <option  value="issued">{{$t('issued')}}</option>
                                        <option  value="refunded">{{$t('refunded')}}</option>
                                    </select>
                            </div>
                        </div>

                        <div class="mb-3">
                            <collapsible-notes-field v-model="localData.notes" id="credit-invoice-notes" rows="1" />
                        </div>

                        <!-- <div class="mb-3">
                            
                            <span v-if="checkIfValidProduct()" @click="invoiceModalisOpen = true" style="cursor:pointer">
                                <AppIcon name="bi-eye" class="bi bi-eye" style="font-size:12px" />
                                <small>&nbsp;{{$t('preview')}}</small>
                            </span>
                            
                        </div> -->

                    </div>

                                    <div class="alert alert-warning" role="alert" v-if="msgError">
                    {{msgError}}
                </div>
            </template>

            <template #footer>
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"><AppIcon name="bi-x-lg" class="bi bi-x-lg me-1" />{{$t('close')}}</button>
                <button v-if="action == 'update'" type="button" class="btn btn-success" @click="updateRow" :disabled="!checkIfValidProduct() || loading"> <AppIcon name="bi-pencil" class="bi bi-pencil" style="font-size:12px" />{{$t('edit')}}</button>
                <button v-if="['create','transfer'].includes(action)" type="button" class="btn btn-success" @click="saveRow" :disabled="!checkIfValidProduct() || loading"><AppIcon name="bi-check-circle" class="bi bi-check-circle me-2" />{{$t('create')}}</button>
            </template>

        </CustomModal>

        <!-- client modal -->
        <add-client v-if="createClientState"  :state="createClientState"  @createClient="createClient"/>
        <!-- client modal -->


        <!-- invoice modal -->
        <invoice-template-modal 
            v-if="invoiceModalisOpen" 
            @modalClosed="invoiceModalisOpen = false" 
            modalId="invoice-invoice-modal-22" 
            :isModalOpen="invoiceModalisOpen"  
            :data="data" 
            type="invoice">
        </invoice-template-modal>
        <!-- invoice modal -->

    </div>
   
    
    
</template>

<script>
import CustomModal from '../CustomModal.vue'
import helper from '../../helper'
import AutoComplete from '../autocomplete/AutoComplete'
import AddClient from '../AddClient.vue'
import InvoiceTemplateModal from '../invoiceLayout/InvoiceTemplateModal.vue'

export default {
  name: 'AddEditInvoiceModal',
  props : {
        action: {
            type: String,
            required: true
        },
        data: {
            default: false
        },
        isModalOpen: {
            type: Boolean,
            default: false
        },
        modalId : {
            type : String,
            default : 'exampleModal'
        }
    },
  components : {
    CustomModal,
    AutoComplete,
    AddClient,
    InvoiceTemplateModal
  },
  data(){
    return {
        loading : false,
        invoiceModalStatus : false,
        invoiceModalisOpen :false,
        createClientState : false,
        hideClient : false,
        localData: JSON.parse(JSON.stringify(this.data)),
        modalIsLoading : false,
        msgError : null
    }
  },
  computed : {
    business(){ return this.$store.getters.BUSINESS},
    total(){ return this.localData.products.length ? this.localData.products.map(o => o.total).reduce((a, c) => { return a + c }) : 0},
    sub_total(){ return this.localData.products.length ? this.localData.products.map(o => o.sub_total).reduce((a, c) => { return a + c }) : 0},
  },
  methods : {
    async saveRow(){
        try{
            this.loading = true
            //format products
            this.localData.products = helper.formatProducts(this.localData.products)
            if(!this.localData.client_id && this.localData.client && this.localData.client.id ){
                this.localData.client_id = this.localData.client.id
            }
            
            for(let i = 0 ; i < this.localData.products.length ; i++){
                if(this.localData.products[i].quantity == 0){
                    this.msgError += `${this.$t('product')}: [${this.localData.products[i].product_label}] ${this.$t('quantity')} :[${this.localData.products[i].quantity}] \n`
                }
            }

            if(!this.localData.products.length){
                this.msgError = `No Product Found`
            }

            if(this.msgError !== null) {
                this.loading = false
                return
            }

            const response = await helper.customPost(`${process.env.VUE_APP_API}/credit-invoices`,{...this.localData },{showToast:true})
            this.clearForm()
            this.loading = false
            this.modalClosed()
            this.$router.push({path : `/credit-invoices/${response.data.id}`})
        }catch(error){
            this.loading = false
        }
    },
    async updateRow(){
        try{
            this.loading = true
            //format products
            this.localData.products = helper.formatProducts(this.localData.products, true)
            if(!this.localData.client_id && this.localData.client && this.localData.client.id ){
                this.localData.client_id = this.localData.client.id
            }
            
            for(let i = 0 ; i < this.localData.products.length ; i++){
                if(this.localData.products[i].quantity == 0){
                    this.msgError += `${this.$t('product')}: [${this.localData.products[i].product_label}] ${this.$t('quantity')} :[${this.localData.products[i].quantity}] \n`
                }
            }

            if(!this.localData.products.length){
                this.msgError = `No Product Found`
            }

            if(this.msgError !== null) {
                this.loading = false
                return
            }
            await helper.customPatch(`${process.env.VUE_APP_API}/credit-invoices/${this.localData.id}`,{...this.localData })
            this.loading = false
            this.clearForm()
            this.modalClosed()
            this.$emit('refresh',true)
        }catch(error){
            this.loading = false
        }
    },
    clearForm(){
        this.localData = {
            id : null,
            reference : '',
            client_id : null,
            client : {},
            date : '',
            total : 0,
            products : []
        }

    },
    addNewRow(){
        this.localData.products.push({
            id : null,
            label : '',
            quantity : 0,
            price : 0,
            discount : 0,
            vat :  this.business.vat,
            total : 0,
            sub_total : 0,
        })
    },
    removeRow(i){
       this.localData.products.splice(i, 1);
    },
    calculatePrices(){
        this.msgError = null
        this.$forceUpdate();
        for(let i = 0 ; i < this.localData.products.length ; i++){
            this.localData.products[i].total = parseFloat(this.localData.products[i].price) * parseFloat(this.localData.products[i].quantity)
            this.localData.products[i].sub_total = Math.round(parseFloat(this.localData.products[i].total))
            if(this.localData.products[i].vat > 0){
                this.localData.products[i].total += parseFloat((parseFloat(this.localData.products[i].total) * parseFloat(this.localData.products[i].vat/ 100)).toFixed(2))
                this.localData.products[i].total = Math.round(this.localData.products[i].total)
            }
        }
        this.localData.total = this.localData.products && this.localData.products.length ? this.localData.products.map(o => o.total).reduce((a, c) => { return a + c }) : 0;
    },
    parseTTctoHt(index,price){
        if(price && price > 0){
           this.localData.products[index].price = ((price / this.localData.products[index].quantity) / 1.2).toFixed(2)
           this.localData.products[index].sub_total = parseFloat(this.localData.products[index].price) * parseFloat(this.localData.products[index].quantity)
        }
    },
    emitAutoComplete(data){
        if(!this.localData.products.length || !this.localData.products.find(product => product.product_id == data.result.product.id)){
            this.localData.products[data.index] = {
                ...{
                inventory_id : data.result.id,
                product_id : data.result.product.id,
                label : data.result.product.label,
                product_label : data.result.product.label,
                // id : data.result.product.id,
                quantity : 0,
                maxQty : data.result.quantity,
                price : data.result.price,
                unity : data.result.unity,
                purchase_price : data.result.purchase_price ? data.result.purchase_price : 0,
                vat :  data.result.vat ? data.result.vat : this.business.vat,
                total : data.result.total ? data.result.total : 0,
                sub_total : data.result.sub_total ? data.result.sub_total : 0,
            }}
            this.localData.products = [...this.localData.products]
        }
    },
    emitAutoCompleteClient(data){
        this.localData.client_id = data.result.id
        this.localData.client = data.result
    },
    openCreateClientModal(){
        this.createClientState = !this.createClientState
    },
    createClient(data){
        if(data.client){
            this.localData.client_id = data.client.id
            this.localData.client = data.client
        }
        if(data && data.state != undefined){
            this.createClientState = data.state
            this.modalIsLoading = true
            setTimeout(() => { this.modalIsLoading = false })
        }
    },
    checkIfValidProduct(){
        return this.localData.products.find(product => product.product_id != null || product.custom_product === true) ? true : false
    },
    modalClosed(){
        this.isModalOpen = false 
        if(document.getElementById('close-modal-btn')){
            document.getElementById('close-modal-btn').click()
        }
        this.clearForm()
        this.$emit('modalClosed', true)
    },
    emitAutoCompleteInvoice(data){
        this.modalIsLoading = true
        this.localData.products = data.result.products
        this.localData.invoice_id = data.result.id
        this.localData.client_id = data.result.client_id
        this.localData.client = data.result.client
        this.calculatePrices()
        setTimeout(() => { this.modalIsLoading = false })
    },
    //helper functions
    formatDate(date,locale) { return helper.formatDate(date,locale) },
    formatMoney(number) { return helper.formatMoney(number);},
    formatReference(number,id) { return helper.formatReference(number,id);}
  }
}
</script>

<style scoped>
    .table-borderless>:not(caption)>*>*{
        padding: 5px !important
    }
</style>
